/* eslint-disable react/prop-types */
import {
  useAuth,
  useFeatureEntitlements,
  usePermissionEntitlements,
} from '@frontegg/react';
import moment from 'moment';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getFromStorage, storeInLocal } from 'src/lib/storage';
import { getHumanScribeStatusAction } from 'src/modules/SuperAdmin/store/actions/humanscribe.action';
import { toast } from '@insight-health-ai/roseate/components';
import UpgradeToProOPModal from './UpgradeToProOPModal.jsx';
import { UpgradeModal } from '../Payments/UpgradeModal';
import {
  createEncounter,
  getEncounter,
  getTranscription,
  listEncounters,
  listPinnedEncounters,
  updateEncounter,
  updateTranscription,
  getScribePractitioners,
} from '../../store/actions/encounter';
import { updateCurrentPractitionerSettings } from '../../../../store/actions/practitioner.action';
import {
  listSummaries,
  updateSummary,
  rollbackSummary,
  getDictateSummary,
  getMagicEditSuggestions,
} from '../../store/actions/summary';
import {
  encounterDetailsSlice,
  newEncounterfromMicSlice,
  resetEncounterState,
  selectedEncounterSlice,
  isOPUpgradeModalVisibleSlice,
  clearPinnedEncounters,
} from '../../store/slices/encounter';
import { resetSummaryState } from '../../store/slices/summary';
import { doStream, endStream } from '../../utils/listen';
import '../CurrentEncounter/CurrentEncounter.scss';
import { NotePreferencesModal } from '../Settings/NotePreferencesModal';
import './PastEncounter.scss';
import PastEncounterMobileView from './PastEncounterMobileView';
import { QRcodeEncounter } from './QRcode.Encounter';
import {
  formatEncounterStatus,
  getEncounterStatus,
} from '../../utils/encounterHelper.js';
import EncounterDesktopView from './EncounterDesktopView.jsx';
import { generateEncounterDescription } from 'src/utils/encounter';
import { analytics } from 'src/services';
import { sanitizeHtmlContent } from 'src/utils';
import {
  clearSelectedTemplate,
  clearTemplateHistory,
} from '../../store/slices/templateSlice.js';
import { useGetOrganizationEhrSettings } from 'src/hooks/settings';
import { EncounterDemo } from 'src/pages/encounter/demo';
import {
  useEmbeddedEncounter,
  clearEmbeddedEncounterId,
} from 'src/hooks/embedded/login';
import { useSelectedEncounter } from 'src/hooks/embedded/useSelectedEncounter';
import { useMicrophoneBadge } from 'src/hooks/vim/hooks/useMicrophoneBadge';

const PastEncounters = ({
  transcriptions,
  encounterListWithColors,
  schedulepage = false,
  appointmentId,
  activeTab = '',
  restrictTemplates = false,
  autoResumeVisit,
  patientDetails,
  isMinimized,
  setIsMinimized,
  setActiveButton: externalSetActiveButton,
  onAutoResumeComplete,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isEntitled: isDictationEntitled } =
    useFeatureEntitlements('dictation');
  const { isEntitled: isDiarizationEntitled } =
    useFeatureEntitlements('diarization');
  const { isEntitled: isRestrictNoteAccessEntitled } =
    usePermissionEntitlements('locked-note-access');

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [recordingTabs, setRecordingTabs] = useState([]);
  const [localActiveButton, setLocalActiveButton] = useState('');

  // Use external setActiveButton when in schedulepage mode, otherwise use local state
  const activeButton = schedulepage ? activeTab : localActiveButton;
  const setActiveButton = schedulepage
    ? externalSetActiveButton
    : setLocalActiveButton;
  const [suggestions, setSuggestions] = useState({});
  const [restrictNoteAccess, setRestrictNoteAccess] = useState(false);
  const setIsUpgradeModalVisible = (value) => {
    dispatch(isOPUpgradeModalVisibleSlice(value));
  };

  const [isUpgradeToProModalVisible, setIsUpgradeToProModalVisible] =
    useState(false);
  const handleUpgradeToProModal = () => {
    setIsUpgradeToProModalVisible(true);
  };

  const {
    currentPractitioner,
    currentPractitionerEntitlements,
    currentPractitionerEntitlementsLoading,
    currentPractitionerSettings,
  } = useSelector((state) => state?.practitionerState);
  const {
    encounterList,
    encounterListCount,
    isEncounterListLoading,
    selectedEncounter,
    isOPUpgradeModalVisible,
    totalEncounterWillBeArchived,
    pinnedEncounterList,
  } = useSelector((state) => state?.encounterState);

  const { ehrSettings } = useGetOrganizationEhrSettings();

  const { quota, timeQuota } = useSelector((state) => state?.quotaState);

  const { settingsOrgValue, getUuid } = useSelector(
    (state) => state?.appointmentState
  );
  const { ehrSubmitDocumentStatus, ehrSubmitDocument } = useSelector(
    (state) => state?.ehrState
  );
  const { summaryList, dictateSummary, magicEditSuggestions } = useSelector(
    (state) => state?.summaryState
  );
  const { recentSearchList = { search_preference: [] } } = useSelector(
    (state) => state?.appointmentState
  );

  // Embedded mode detection - pre-filter by encounter when embedded with ehr_id
  const { embeddedEncounterId, isEmbeddedWithEncounter } =
    useEmbeddedEncounter();

  // Selected encounter storage (uses sessionStorage for window isolation)
  const { getSelectedEncounter, setSelectedEncounter, clearSelectedEncounter } =
    useSelectedEncounter(currentPractitioner?.org_uuid);

  const storeSavedTabMobile = getFromStorage(
    `${currentPractitioner?.org_uuid}_selectedTab`
  );
  const medicalConversationBoxRef = useRef(null);
  const [waitingForSocketConnection, setwaitingForSocketConnection] =
    useState(false);
  const [dictationStarted, setDictationStarted] = useState(false);
  const [selectedTab, setSelectedTab] = useState(
    storeSavedTabMobile ? storeSavedTabMobile : 'Today'
  );
  const [auraView, setAuraView] = useState('LIST');

  const [selectedDate, setSelectedDate] = useState(
    storeSavedTabMobile
      ? storeSavedTabMobile
      : localStorage.getItem(`${currentPractitioner?.org_uuid}_selectedFilter`)
        ? localStorage.getItem(
            `${currentPractitioner?.org_uuid}_selectedFilter`
          )
        : 'Today'
  );
  const [isRecording, setIsRecording] = useState(false);
  const [isStreaming, setIsStreaming] = useState(false);
  const [isChartStreaming, setIsChartStreaming] = useState(false);
  const [isVisitStreaming, setIsVisitStreaming] = useState(false);
  const [isChartRecording, setIsChartRecording] = useState(false);
  const [isVisitRecording, setIsVisitRecording] = useState(false);

  useMicrophoneBadge(isRecording || isChartRecording || isVisitRecording);

  const [encountersRemaining, setEncountersRemaining] = useState(0);
  const [timeBasedQuotaDaysRemaining, setTimeBasedQuotaDaysRemaining] =
    useState(0);
  const [activeRightPanelTab, setActiveRightPanelTab] = useState('live');
  const [isNewEncounterCreated, setIsNewEncounterCreated] = useState(false);
  const { isEntitled: isHumanScribeEntitled } =
    useFeatureEntitlements('custom-workflow');

  // settings if loaded from appointments page
  // in appointments page we only show one encounter
  const pageSize = schedulepage ? 1 : 5;

  // Initialize sortState from practitioner settings or use default
  const getSavedSortState = () => {
    const sortPrefs =
      currentPractitionerSettings?.note_preferences?.sort_preferences
        ?.past_encounters;
    return (
      sortPrefs || {
        field: 'start_time',
        order: 'desc',
      }
    );
  };

  const [sortState, setSortState] = useState(getSavedSortState());

  useEffect(() => {
    const getSortState = () => {
      const sortPrefs =
        currentPractitionerSettings?.note_preferences?.sort_preferences
          ?.past_encounters;
      return (
        sortPrefs || {
          field: 'start_time',
          order: 'desc',
        }
      );
    };

    const newSortState = getSortState();
    setSortState(newSortState);
  }, [currentPractitionerSettings]);

  //  reset state on initial load and when appointmentId changes to avoid ghosting
  useEffect(() => {
    // If opening in combo view, we have to reset the 'last selected encounter' state in LS
    // to avoid opening the wrong encounter when switching between appointments
    if (schedulepage || isEmbeddedWithEncounter) {
      clearSelectedEncounter();
      // Clean up state on unmount or appointment change
      dispatch(resetEncounterState());
      dispatch(resetSummaryState());
    }
  }, [
    schedulepage,
    appointmentId,
    embeddedEncounterId,
    isEmbeddedWithEncounter,
    dispatch,
  ]);

  const [editingRow, setEditingRow] = useState(null);
  const [browserTimezone, setBrowserTimezone] = useState('');
  const [utcTime, setUtcTime] = useState('');
  const { user } = useAuth();
  const { humanScribeStatus } = useSelector((state) => state.humanScribeState);
  useEffect(() => {
    dispatch(getMagicEditSuggestions());

    if (isHumanScribeEntitled) {
      dispatch(getScribePractitioners());
      dispatch(getHumanScribeStatusAction());
    }
  }, []);

  useEffect(() => {
    setSuggestions(magicEditSuggestions);
  }, [magicEditSuggestions]);

  useEffect(() => {
    if (!currentPractitioner?.org_uuid || !currentPractitionerSettings) return;

    const handler = setTimeout(() => {
      const currentSortPrefs =
        currentPractitionerSettings?.note_preferences?.sort_preferences
          ?.past_encounters;

      // Only update if the sort state has actually changed
      if (JSON.stringify(currentSortPrefs) !== JSON.stringify(sortState)) {
        const updatedSettings = {
          note_preferences: {
            ...currentPractitionerSettings?.note_preferences,
            sort_preferences: {
              ...currentPractitionerSettings?.note_preferences
                ?.sort_preferences,
              past_encounters: sortState,
            },
          },
        };

        dispatch(updateCurrentPractitionerSettings(updatedSettings));
      }
    }, 1000); // Debounce for 1 second

    return () => {
      clearTimeout(handler);
    };
  }, [
    sortState,
    currentPractitioner?.org_uuid,
    currentPractitionerSettings,
    dispatch,
  ]);

  const reloadTranscription = () => {
    setFullTranscript([]);
    setLiveTranscript([]);
    setLivePartialTranscript('');
    initTranscript.current = false;
    dispatch(
      getTranscription(selectedEncounter?.encounter_id, encounterPhase, 'live')
    );
    if (isDiarizationEntitled) {
      dispatch(
        getTranscription(
          selectedEncounter?.encounter_id,
          encounterPhase,
          'prerecorded'
        )
      );
    }
  };

  const handleEditTranscription = (
    transcriptionType,
    fullTranscript,
    action = 'update'
  ) => {
    let transcription_id;
    if (transcriptionType == 'live') {
      transcription_id = transcriptionbyIdValue[0]?.transcription_id;
    } else {
      transcription_id = prerecordedTranscriptId;
    }
    const new_transcription = {
      transcription_json: fullTranscript,
    };
    dispatch(
      updateTranscription(transcription_id, new_transcription, {
        onSuccess: () => {
          if (action === 'delete') {
            toast.success('Transcription deleted successfully');
          } else {
            toast.success('Transcription updated successfully');
          }
          reloadTranscription();
        },
        onError: () => {
          toast.error('Failed to update transcription');
        },
      })
    );
  };

  //logged in user's id

  const savedPractitioner_ID = getFromStorage(
    `${currentPractitioner?.org_uuid}_storePractitioner`
  );

  const dictationHotkeyHandler = (event) => {
    if (isDictationEntitled && event.ctrlKey && event.key === 'i') {
      if (dictationStarted) {
        endStream();
        setwaitingForSocketConnection(false);
        setDictationStarted(false);
        medicalConversationBoxRef.current?.stopDictation();
      } else {
        handleDictation();
      }
    }
  };

  useEffect(() => {
    if (selectedEncounter?.encounter_id !== undefined) {
      const { displayStatus } = formatEncounterStatus(selectedEncounter);
      if (
        displayStatus === 'Completed' ||
        displayStatus === 'Copied to EHR' ||
        displayStatus === 'Saved to EHR' ||
        displayStatus === 'Pre-chart completed'
      ) {
        window.addEventListener('keydown', dictationHotkeyHandler);
        return () => {
          window.removeEventListener('keydown', dictationHotkeyHandler);
        };
      }
    }
  }, [dictationStarted, selectedEncounter]);

  const handleDictation = () => {
    if (encounterPhase === 'dictate') {
      analytics.track('Clicked Start Dictation From Solo Dictation', {
        email: user?.email,
      });
    } else {
      analytics.track('Started dictation', { email: user?.email });
    }

    setIsDictateTooltipOpen(false);
    setwaitingForSocketConnection(true);
    doStream({
      encounterId: selectedEncounter?.encounter_id,
      encounterPhase: '',
      setMicLevel: () => {},
      setLiveTranscript: null,
      setLivePartialTranscript: null,
      selectedMicrophoneId: medicalConversationBoxRef.current?.getMicrophone(),
      successCallback: () => {
        setwaitingForSocketConnection(false);
        setDictationStarted(true);
        medicalConversationBoxRef.current?.setEditorFocus();
      },
      failureCallback: (error) => {
        setwaitingForSocketConnection(false);
        medicalConversationBoxRef.current?.handleSocketErrors(error);
      },
      setDictation: medicalConversationBoxRef.current?.setDictationText,
      isDictate: true,
      transcriptTimeoutCallback: () => {},
    });
  };

  const savedStartDate_Storage = localStorage.getItem(
    `${currentPractitioner?.org_uuid}_startDate`
  );
  const savedEndDate_Storage = localStorage.getItem(
    `${currentPractitioner?.org_uuid}_endDate`
  );

  const [savedStartDate, setSavedStartDate] = useState(
    savedStartDate_Storage ? savedStartDate_Storage : null
  );
  const [savedEndDate, setSavedEndDate] = useState(
    savedEndDate_Storage ? savedEndDate_Storage : null
  );

  useEffect(() => {
    if (savedStartDate_Storage) {
      const finalStartDateObj = moment(savedStartDate_Storage)
        .startOf('day')
        .tz(moment.tz.guess())
        .format();
      setSavedStartDate(finalStartDateObj);
    }
    if (savedEndDate_Storage) {
      const finalEndDateObj = moment(savedEndDate_Storage)
        .startOf('day')
        .tz(moment.tz.guess())
        .format();
      setSavedEndDate(finalEndDateObj);
    }
  }, [savedStartDate_Storage, savedEndDate_Storage]);

  const storedPractitioner = localStorage.getItem(
    `${currentPractitioner?.org_uuid}_selectedPractitioner`
  );
  const storedStatus = localStorage.getItem(
    `${currentPractitioner?.org_uuid}_savedStatus`
  );
  const storedFilter =
    storedStatus ||
    storedPractitioner ||
    savedStartDate_Storage ||
    savedEndDate_Storage;

  const initialValues = {
    practitioner_id: storedPractitioner ? storedPractitioner : '',
    status: storedStatus ? storedStatus : '',
  };
  const [searchFilters, setSearchFilters] = useState(initialValues);

  // states for auto-save functionality
  const [editedSummary, setEditedSummary] = useState('');
  const editableSummaryRef = useRef(null);
  const lastUpdatedSummaryRef = useRef(null);
  const [isSummaryOutdated, setIsSummaryOutdated] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const isMagicEditingRef = useRef(null);

  // states for live transcription
  const [liveTranscript, setLiveTranscript] = useState([]);
  const [livePartialTranscript, setLivePartialTranscript] = useState('');
  const [fullTranscript, setFullTranscript] = useState([]);
  const initTranscript = useRef(false);

  const [encounterStatus, setEncounterStatus] = useState('');
  const [encounterPhase, setEncounterPhase] = useState('in-visit');
  const [storedParams, setStoredParams] = useState('');
  const [record, setRecord] = useState('');
  const defaultDescription = 'Encounter';
  const isMobileView = window.innerWidth <= 1260;
  const [topBarInputs, setTopBarInputs] = useState({
    description: defaultDescription,
    patient_name: '',
  });
  const {
    transcriptionbyIdValue,
    prerecordedTranscriptId,
    newEncounterfromMic,
  } = useSelector((state) => state?.encounterState);
  const [isQRCodeOpen, setIsQRCodeOpen] = useState(false);
  const [storeQRcodeId, setStoreQRcodeId] = useState('');
  const [isCustomSelected, setIsCustomSelected] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [isRowDoubleClicked, setIsRowDoubleClicked] = useState(false);
  const [isDictateTooltipOpen, setIsDictateTooltipOpen] = useState(false);
  const [isTranscribing, setIsTranscribing] = useState(false);

  useEffect(() => {
    if (activeTab) {
      setActiveButton(activeTab);
    }
  }, [activeTab]);

  const [auraDemoOpen, setAuraDemoOpen] = useState(null);
  const [practitonerPreferenceModal, setPractitonerPreferenceModal] =
    useState(false);

  useEffect(() => {
    if (
      !currentPractitionerEntitlementsLoading &&
      currentPractitionerEntitlements
    ) {
      if (currentPractitionerEntitlements?.request_note_preferences) {
        setAuraDemoOpen(null);
        setPractitonerPreferenceModal(true);
      } else {
        setPractitonerPreferenceModal(false);
        if (
          currentPractitionerEntitlements?.show_onboarding_demo ||
          new URLSearchParams(window.location.search).has(
            '__internal_aura_demo_modal__'
          )
        ) {
          setAuraDemoOpen({});
        }
      }
    }
  }, [
    currentPractitionerEntitlementsLoading,
    currentPractitionerEntitlements,
    settingsOrgValue?.is_self_signup,
  ]);

  useEffect(() => {
    editableSummaryRef.current = null;
    initTranscript.current = false;
    setLivePartialTranscript('');
    if (!isTranscribing || !schedulepage) {
      setLiveTranscript([]);
    }
    if (!isTranscribing) {
      setFullTranscript([]);
    }
    setIsSummaryOutdated(false);
  }, [encounterPhase]);

  useEffect(() => {
    if (
      isChartStreaming ||
      isChartRecording ||
      isVisitStreaming ||
      isVisitRecording
    ) {
      setIsTranscribing(true);
    } else {
      setIsTranscribing(false);
    }
  }, [
    isChartRecording,
    selectedEncounter?.encounter_id,
    isChartStreaming,
    isTranscribing,
    isVisitRecording,
    isVisitStreaming,
    encounterPhase,
  ]);

  const handleRowDoubleClick = (record) => {
    if (!editingRow || editingRow.encounter_id !== record.encounter_id) {
      setIsFullScreen(!isFullScreen);
      setIsRowDoubleClicked(true);
    }
  };

  const handleBackMobileIconClick = () => {
    setIsRowDoubleClicked(false);
  };

  useEffect(() => {
    const currentTranscription = transcriptionbyIdValue[0];
    const transcriptData = currentTranscription?.transcription_json || [];

    if (!initTranscript.current && currentTranscription?.type === 'live') {
      setLiveTranscript(transcriptData);
      initTranscript.current = true;
    }

    if (isNewEncounterCreated && transcriptData.length === 0) {
      setLiveTranscript([]);
      setFullTranscript([]);
      setIsNewEncounterCreated(false);
    }
  }, [transcriptionbyIdValue]);

  const [isScribeSelected, setIsScribeSelected] = useState(false);
  const [selectedPractitioner, setSelectedPractitioner] = useState(null);

  const [selectedEncounterValue, setSelectedEncounterValue] = useState(null);

  // Initialize selectedPractitioner when currentPractitioner is loaded
  useEffect(() => {
    if (currentPractitioner?.practitioner_id) {
      if (savedPractitioner_ID === 'All') {
        setSelectedPractitioner('All');
      } else if (
        savedPractitioner_ID &&
        !isNaN(parseInt(savedPractitioner_ID))
      ) {
        setSelectedPractitioner(parseInt(savedPractitioner_ID));
      } else {
        // Default to current practitioner if no saved preference
        setSelectedPractitioner(currentPractitioner?.practitioner_id);
      }
    }
  }, [currentPractitioner?.practitioner_id, savedPractitioner_ID]);

  useEffect(() => {
    if (isHumanScribeEntitled && record?.encounter_id) {
      if (
        ['in_progress', 'in_review', 'complete', 'shipped'].includes(
          record?.encounter_status
        ) &&
        record?.assigned_scribe_id !== null &&
        record?.assigned_scribe_id !== currentPractitioner?.practitioner_id &&
        !isRestrictNoteAccessEntitled
      ) {
        setRestrictNoteAccess(true);
      } else {
        setRestrictNoteAccess(false);
      }
    }
  }, [
    isHumanScribeEntitled,
    record?.encounter_id,
    record?.encounter_status,
    record?.assigned_scribe_id,
    currentPractitioner?.practitioner_id,
    isRestrictNoteAccessEntitled,
  ]);

  useEffect(() => {
    setSelectedEncounterValue(selectedEncounter?.encounter_id);
    if (dictationStarted) {
      endStream();
      setwaitingForSocketConnection(false);
      setDictationStarted(false);
      medicalConversationBoxRef.current?.stopDictation();
    }
  }, [selectedEncounter, activeButton]);

  useEffect(() => {
    const detectUserTimezone = () => {
      const userTimezone = moment.tz.guess();
      setBrowserTimezone(userTimezone);
    };

    detectUserTimezone();
  }, []);

  //Function to add timestamp to selected date in mobile view
  useEffect(() => {
    const convertToUTC = () => {
      if (browserTimezone) {
        const currentTime = moment().tz(browserTimezone);
        const utcTime = currentTime.clone().utc();
        const utcTimeString = utcTime.format('HH:mm');
        const offset = currentTime.utcOffset();
        const sign = offset >= 0 ? '+' : '-';
        const hours = Math.floor(Math.abs(offset) / 60);
        const minutes = Math.abs(offset) % 60;
        const formattedOffset = `${sign}${hours
          .toString()
          .padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        const formattedUtcTime = `${utcTimeString}${formattedOffset}`;
        setUtcTime(formattedUtcTime);
      }
    };

    convertToUTC();
  }, [browserTimezone]);

  const handleCancelModal = () => {
    setIsCustomSelected(false);
    setModalVisible(false);
  };

  const today = moment().format('YYYY-MM-DD');

  const [selectedTabDate, setSelectedTabDate] = useState(today);
  const [selectedLastWeek, setSelectedLastWeek] = useState(
    storeSavedTabMobile === 'Past 7 days' ? 'Past 7 days' : null
  );

  const [pageState, setPageState] = useState({
    current: 1,
    pageSize: pageSize,
  });

  // Dynamic polling interval based on the status of the encounter.
  // if any of the encounter has a status summary_inprogress, then we aggressively poll every 10 seconds.
  // if not, we poll every minute to reduce load on the server.
  const [refreshInterval, setRefreshInterval] = useState(60_000);

  const calculateRefreshInterval = () => {
    const isGeneratingSummary =
      Array.isArray(encounterList) &&
      encounterList.some(
        (encounter) =>
          encounter.in_visit_status === 'summary_inprogress' ||
          encounter.pre_chart_status === 'summary_inprogress' ||
          encounter.after_visit_status === 'summary_inprogress' ||
          (hasICD10Access &&
            encounter.in_visit_status === 'completed' &&
            encounter.icd_10_status !== 'ready') ||
          (hasSNOMEDAccess &&
            encounter.in_visit_status === 'completed' &&
            encounter.snomed_status !== 'ready') ||
          (hasCPTAccess &&
            encounter.in_visit_status === 'completed' &&
            encounter.cpt_status !== 'ready')
      );
    let newRefreshInterval = 60_000;
    if (isGeneratingSummary) {
      newRefreshInterval = 10_000;
    }
    if (newRefreshInterval !== refreshInterval) {
      setRefreshInterval(newRefreshInterval);
    }
  };

  // 5 seconds
  const autoSaveInterval = 5_000;
  const lastPolledEncounterParams = useRef({});

  // Add this helper function to normalize text for comparison
  const normalizeSummaryText = (text) => {
    if (!text) return '';

    // Create a temporary DOM element to decode HTML entities
    const doc = new DOMParser().parseFromString(text, 'text/html');
    return doc.body.textContent
      .replace(/<br\s*\/?>/g, '\n') // Convert <br> to newlines
      .replace(/\s+/g, ' ') // Normalize whitespace
      .trim(); // Remove leading/trailing whitespace
  };
  const { selectedTemplate } = useSelector((state) => state?.template);
  // Auto-save functionality begins here
  useEffect(() => {
    const updateNewSummary = (summary) => {
      const cleaned_summary = {
        ...summary,
      };
      if (typeof summary.summary_json === 'string') {
        cleaned_summary.summary_json = summary.summary_json
          .replaceAll('\n', '<br>')
          .replaceAll('\\n', '<br>');
      }

      let updatedSummary = false;

      // if its a different encounter or encounter phase, we need to update the summary
      if (
        editableSummaryRef.current?.encounter_id !=
          cleaned_summary.encounter_id ||
        editableSummaryRef.current?.encounter_phase !=
          cleaned_summary.encounter_phase
      ) {
        updatedSummary = true;
      } else {
        // if its a new summary version, we only render the new summary if the last updated summary was from AI
        if (editableSummaryRef.current.version != cleaned_summary.version) {
          updatedSummary = true;
        }
      }

      if (updatedSummary) {
        editableSummaryRef.current = cleaned_summary;
        setEditedSummary({ ...cleaned_summary });
        lastUpdatedSummaryRef.current = { ...cleaned_summary };
      }
    };

    setIsSummaryOutdated(false);

    // when the summary is generating or re-generation clear ref to summary
    // to ensured the updated summary is loaded when it's ready
    if (encounterStatus !== 'completed' && encounterPhase !== 'dictate') {
      editableSummaryRef.current = null;
      setEditedSummary('');
      setIsSummaryOutdated(false);
    } else if (encounterStatus === 'completed' && summaryList?.length > 0) {
      const summary = summaryList.find(
        (summary) => summary.encounter_phase === encounterPhase
      );

      if (!summary) {
        return;
      }
      if (selectedTemplate && encounterPhase === 'after-visit') {
        updateNewSummary(selectedTemplate?.summary_data);
      } else {
        updateNewSummary(summary);
      }
    } else if (encounterPhase === 'dictate' && dictateSummary?.length > 0) {
      const summary = dictateSummary.find(
        (summary) => summary.encounter_phase === encounterPhase
      );

      if (!summary) {
        return;
      }

      updateNewSummary(summary);
    }
  }, [
    summaryList,
    dictateSummary,
    encounterStatus,
    encounterPhase,
    selectedTemplate,
  ]);

  useEffect(() => {
    let saveTimeout;

    const autoSave = () => {
      // Handle race condition where the encounter is changed before the summary is saved
      if (selectedEncounter?.encounter_id !== editedSummary?.encounter_id) {
        return;
      }

      dispatch(
        updateSummary(
          selectedEncounter?.encounter_id,
          encounterPhase,
          editedSummary?.summary_json,
          editedSummary?.version,
          lastUpdatedSummaryRef,
          editableSummaryRef,
          setEditedSummary,
          setIsSaving
        )
      );
    };

    const hasChanged =
      normalizeSummaryText(editedSummary?.summary_json) !==
      normalizeSummaryText(lastUpdatedSummaryRef.current?.summary_json);

    if (
      (encounterStatus == 'completed' || encounterPhase == 'dictate') &&
      editedSummary?.summary_json != null &&
      lastUpdatedSummaryRef.current?.summary_json != null &&
      !isSummaryOutdated &&
      !isMagicEditingRef.current &&
      selectedEncounter?.encounter_id === editedSummary?.encounter_id &&
      hasChanged
    ) {
      clearTimeout(saveTimeout);
      saveTimeout = setTimeout(autoSave, autoSaveInterval);
      setIsSaving(true);
    }

    return () => clearTimeout(saveTimeout);
  }, [encounterStatus, editedSummary]);

  const handleSummaryEdits = (value) => {
    if (editableSummaryRef.current) {
      editableSummaryRef.current.summary_json = value;
      setEditedSummary({
        ...editableSummaryRef.current,
        summary_json: value,
      });
    }
  };
  // Auto-save functionality ends here

  const handleEncountersSorting = () => {
    const newOrder = sortState.order === 'asc' ? 'desc' : 'asc';
    const orderState = { ...sortState, order: newOrder };
    setSortState(orderState);

    dispatch(selectedEncounterSlice(null));
    clearSelectedEncounter();
  };

  //Triggers initial api call to list encounters
  useEffect(() => {
    if (!currentPractitioner?.practitioner_id) {
      return;
    }

    const effectivePractitionerId =
      selectedPractitioner || currentPractitioner.practitioner_id;

    let params = {
      ...searchFilters,
      practitioner_id: effectivePractitionerId,
      page: pageState.current,
      per_page: pageState.pageSize,
    };

    if (sortState.field) {
      params.sort_by = sortState.field;
      params.sort_direction = sortState.order;
    }

    const setDateParams = (startDateValue, endDateValue) => {
      // if (auraView === 'CALENDAR') {
      //   // Use start_date_gt and start_date_lt for Calendar view
      //   params.start_date_gt = startDateValue;
      //   params.start_date_lt = endDateValue;
      // } else {
      //   // Use created_at_gt and created_at_lt for List view
      //   params.created_at_gt = startDateValue;
      //   params.created_at_lt = endDateValue;
      // }

      //TODO: IH-3557 Advanced date / time encounter creation shows created date / time
      params.start_date_gt = startDateValue;
      params.start_date_lt = endDateValue;
    };

    if (
      selectedDate === 'Custom…🗓️' &&
      startDate &&
      endDate &&
      !isMobileView &&
      !schedulepage
    ) {
      setDateParams(
        moment(startDate).startOf('day').tz(moment.tz.guess()).format(),
        moment(endDate).endOf('day').tz(moment.tz.guess()).format()
      );
    } else if (selectedDate === 'Today' && !isMobileView && !schedulepage) {
      setDateParams(
        moment().startOf('day').tz(moment.tz.guess()).format(),
        moment().endOf('day').tz(moment.tz.guess()).format()
      );
    } else if (selectedDate === 'Yesterday' && !isMobileView && !schedulepage) {
      setDateParams(
        moment()
          .subtract(1, 'days')
          .startOf('day')
          .tz(moment.tz.guess())
          .format(),
        moment().subtract(1, 'days').endOf('day').tz(moment.tz.guess()).format()
      );
    } else if (
      selectedDate === 'Past 7 days' &&
      !isMobileView &&
      !schedulepage
    ) {
      setDateParams(
        moment()
          .subtract(6, 'days')
          .startOf('day')
          .tz(moment.tz.guess())
          .format(),
        moment().endOf('day').tz(moment.tz.guess()).format()
      );
    } else if (isMobileView && !schedulepage && selectedLastWeek === null) {
      if (selectedTab === 'Today') {
        setDateParams(
          moment().startOf('day').tz(moment.tz.guess()).format(),
          moment().endOf('day').tz(moment.tz.guess()).format()
        );
      } else if (selectedTab === 'Yesterday') {
        setDateParams(
          moment()
            .subtract(1, 'days')
            .startOf('day')
            .tz(moment.tz.guess())
            .format(),
          moment()
            .subtract(1, 'days')
            .endOf('day')
            .tz(moment.tz.guess())
            .format()
        );
      }
    } else if (isMobileView && selectedLastWeek && !schedulepage) {
      setDateParams(
        moment()
          .subtract(6, 'days')
          .startOf('day')
          .tz(moment.tz.guess())
          .format(),
        moment().endOf('day').tz(moment.tz.guess()).format()
      );
    } else if (savedStartDate && savedEndDate) {
      setDateParams(savedStartDate, savedEndDate);
    } else if (isMobileView && !schedulepage) {
      if (storeSavedTabMobile === 'Today') {
        setDateParams(
          moment().startOf('day').tz(moment.tz.guess()).format(),
          moment().endOf('day').tz(moment.tz.guess()).format()
        );
      } else if (storeSavedTabMobile === 'Yesterday') {
        setDateParams(
          moment()
            .subtract(1, 'days')
            .startOf('day')
            .tz(moment.tz.guess())
            .format(),
          moment()
            .subtract(1, 'days')
            .endOf('day')
            .tz(moment.tz.guess())
            .format()
        );
      } else if (storeSavedTabMobile === 'Past 7 days') {
        setDateParams(
          moment()
            .subtract(6, 'days')
            .startOf('day')
            .tz(moment.tz.guess())
            .format(),
          moment().endOf('day').tz(moment.tz.guess()).format()
        );
      } else if (storeSavedTabMobile === 'All time') {
        setDateParams('', '');
      }
    }

    if (params.practitioner_id === 'All') {
      delete params.practitioner_id;
    }

    // If opening in combo view, we don't want to pass any other param apart from appointment_id
    if (schedulepage) {
      params = {
        appointment_id: appointmentId,
      };
    }

    if (isScribeSelected) {
      params.scribe_practitioner = true;
    } else {
      delete params.scribe_practitioner;
    }

    setTimeout(() => {
      // Make two separate API calls
      dispatch(listEncounters(params, true)); // Normal encounters (is_pinned: false)
      dispatch(listPinnedEncounters()); // Pinned encounters
    }, 500);
    setStoredParams(params);

    const intervalId = setInterval(() => {
      if (!isMagicEditingRef.current) {
        // Make two separate API calls
        dispatch(listEncounters(params, false)); // Normal encounters (is_pinned: false)
        dispatch(listPinnedEncounters()); // Pinned encounters
      }
    }, refreshInterval);

    return () => clearInterval(intervalId);
  }, [
    currentPractitioner?.practitioner_id,
    utcTime,
    searchFilters,
    sortState,
    pageState,
    startDate,
    endDate,
    selectedTabDate,
    selectedLastWeek,
    selectedTab,
    selectedDate,
    selectedPractitioner,
    isScribeSelected,
    savedStartDate,
    savedEndDate,
    refreshInterval,
    isMobileView,
    auraView,
    embeddedEncounterId,
  ]);

  useEffect(() => {
    if (settingsOrgValue?.onboarding_demo === true) {
      analytics.track('Viewed Aura Encounters', { email: user?.email });
    }
  }, [settingsOrgValue?.onboarding_demo]);

  //
  // Fetch encounter list every refreshInterval seconds.
  //
  useEffect(() => {
    if (encounterList?.length > 0 || pinnedEncounterList?.length > 0) {
      // Only auto-select an encounter if none is currently selected
      // This preserves user's manual selection when encounter lists refresh
      if (!selectedEncounter?.encounter_id) {
        const hasPinnedEncounters = pinnedEncounterList?.length > 0;

        // When pinned encounters exist, only auto-select from pinned list
        // When embedded with encounter, wait for pinned encounters to load - don't fall back to regular list
        if (hasPinnedEncounters) {
          const selectedEncounterDetails = pinnedEncounterList[0];
          if (selectedEncounterDetails) {
            setCurrentEncounter(selectedEncounterDetails);
            dispatch(selectedEncounterSlice(selectedEncounterDetails));
            if (!schedulepage) {
              setSelectedEncounter(selectedEncounterDetails);
            }
          }
        } else if (!isEmbeddedWithEncounter) {
          // Only auto-select from regular list if NOT in embedded mode
          // (embedded mode expects pinned encounters which may load slower)
          const selectedEncounterDetails = encounterList?.[0];
          if (selectedEncounterDetails) {
            setCurrentEncounter(selectedEncounterDetails);
            dispatch(selectedEncounterSlice(selectedEncounterDetails));
            if (!schedulepage) {
              setSelectedEncounter(selectedEncounterDetails);
            }
          }
        }
      }

      calculateRefreshInterval();
    }
  }, [encounterList, pinnedEncounterList, isEmbeddedWithEncounter]); // Depend on both encounter lists and embedded mode

  //
  // Fetch summaries and transcriptions when:
  // - selected encounter ID / phase changes (via navigation)
  // - selected encounter's status changes
  //
  useEffect(() => {
    const selectedEncounterId = selectedEncounter?.encounter_id;

    if (
      selectedEncounterId &&
      encounterStatus &&
      (lastPolledEncounterParams.current?.encounter_id !==
        selectedEncounterId ||
        lastPolledEncounterParams.current?.encounter_phase !== encounterPhase ||
        lastPolledEncounterParams.current?.encounter_status !==
          encounterStatus ||
        lastPolledEncounterParams.current?.cpt_status !==
          selectedEncounter?.cpt_status ||
        lastPolledEncounterParams.current?.icd_10_status !==
          selectedEncounter?.icd_10_status)
    ) {
      lastPolledEncounterParams.current = {
        encounter_id: selectedEncounterId,
        encounter_phase: encounterPhase,
        encounter_status: encounterStatus,
        cpt_status: selectedEncounter?.cpt_status,
        icd_10_status: selectedEncounter?.icd_10_status,
      };

      dispatch(getEncounter(selectedEncounterId));
      dispatch(listPinnedEncounters());
      dispatch(listSummaries(selectedEncounterId, encounterPhase, 'ambient'));
      dispatch(listSummaries(selectedEncounterId, encounterPhase, 'dictate'));
      dispatch(getTranscription(selectedEncounterId, encounterPhase, 'live'));

      if (isDiarizationEntitled) {
        dispatch(
          getTranscription(selectedEncounterId, encounterPhase, 'prerecorded')
        );
      }
    }
  }, [
    selectedEncounter?.encounter_id,
    encounterPhase,
    encounterStatus,
    selectedEncounter?.cpt_status,
    selectedEncounter?.icd_10_status,
    lastPolledEncounterParams,
    dispatch,
    isDiarizationEntitled,
  ]);
  const changeEncounterStatus = (encounter_id) => {
    const currentEncounter = [
      ...(pinnedEncounterList || []),
      ...(encounterList || []),
    ].find((encounter) => encounter?.encounter_id === encounter_id);
    if (currentEncounter) {
      setEncounterStatus(getEncounterStatus(currentEncounter, encounterPhase));
    }
  };
  useEffect(() => {
    if (encounterList?.length > 0 || pinnedEncounterList?.length > 0) {
      const hasPinnedEncounters = pinnedEncounterList?.length > 0;
      // When pinned encounters exist or embedded mode, only use pinned list for status updates
      // In embedded mode, wait for pinned encounters - don't fall back to regular list
      let selectedEncounterId = selectedEncounter?.encounter_id;
      if (!selectedEncounterId) {
        if (hasPinnedEncounters) {
          selectedEncounterId = pinnedEncounterList[0]?.encounter_id;
        } else if (!isEmbeddedWithEncounter) {
          selectedEncounterId = encounterList[0]?.encounter_id;
        }
      }
      if (selectedEncounterId) {
        changeEncounterStatus(selectedEncounterId);
      }
    }
  }, [
    encounterList,
    pinnedEncounterList,
    encounterPhase,
    isEmbeddedWithEncounter,
  ]);

  useEffect(() => {
    setEncountersRemaining(quota?.encounters?.remaining);
  }, [quota?.encounters?.remaining]);

  useEffect(() => {
    setTimeBasedQuotaDaysRemaining(timeQuota?.remaining_days);
  }, [timeQuota?.remaining_days]);

  const handleCreateEncounter = async (practitionerId, customOptions = {}) => {
    if (
      timeBasedQuotaDaysRemaining !== null &&
      timeBasedQuotaDaysRemaining <= 0
    ) {
      setIsUpgradeModalVisible(true);
      return;
    }
    if (encountersRemaining !== null && encountersRemaining <= 0) {
      setIsUpgradeModalVisible(true);
      return;
    }

    const {
      description,
      callback,
      demo,
      is_pinned_encounter,
      zoom_meeting_id,
    } = {
      description: null,
      is_pinned_encounter: false,
      zoom_meeting_id: null,
      ...customOptions,
    };

    // Clear pinned encounter state when user manually creates a new encounter
    // This removes the pinned encounter view and makes all encounters selectable
    dispatch(clearPinnedEncounters());
    clearEmbeddedEncounterId();

    setSearchFilters('');
    storeInLocal(
      `${currentPractitioner?.org_uuid}_storePractitioner`,
      practitionerId
    );
    dispatch(newEncounterfromMicSlice(true));
    dispatch(encounterDetailsSlice(null));
    setSelectedDate('Today');
    setSelectedTab && setSelectedTab('Today');
    setStartDate(null);
    setEndDate(null);
    // Create a new encounter
    const defaultDescription =
      description || generateEncounterDescription({ prefix: 'Encounter' });
    const data = {
      description: defaultDescription,
      practitioner_id:
        !isMobileView && !schedulepage
          ? practitionerId
          : currentPractitioner.practitioner_id,
      start_time: moment().local().toISOString(),
      is_pinned_encounter: is_pinned_encounter,
    };

    // Add zoom meeting ID if provided
    if (zoom_meeting_id) {
      data.zoom_meeting_id = zoom_meeting_id;
    }

    // if (demo) {
    //   data.type = 'ambient-demo';
    // }

    if (schedulepage && appointmentId) {
      data.appointment_id = appointmentId;
    }
    setLiveTranscript([]);
    setFullTranscript([]);
    setLivePartialTranscript('');
    setIsTranscribing(false);
    dispatch(selectedEncounterSlice(null));
    clearSelectedEncounter();
    setSelectedTab('Today');
    setSelectedLastWeek(null);
    setSelectedTabDate(today);
    setIsNewEncounterCreated(true);
    const trackEvents = () => {
      if (demo) {
        analytics.track('Created New Ambient Encounter From Retry Demo', {
          mobile: isMobileView,
          email: user?.email,
        });
        return;
      }

      if (schedulepage) {
        analytics.track('Created New Ambient Encounter From VCA', {
          email: user?.email,
        });
      } else {
        analytics.track('Created New Ambient Encounter From Aura', {
          email: user?.email,
        });
      }
    };

    const desktopCallback = async (createdEncounter) => {
      trackEvents();
      setRecord(createdEncounter);
      await dispatch(selectedEncounterSlice(createdEncounter));
      setSelectedEncounter(createdEncounter);
      setEncounterStatus(createdEncounter.status);
      setPageState({
        current: 1,
        pageSize: 10,
      });
      changeEncounterStatus(record?.encounter_id);
      initTranscript.current = false;
      callback?.(createdEncounter);
    };
    const mobileCallback = (createdEncounter) => {
      trackEvents();

      // IMPORTANT: in mobile do not redirect when callback is provided to avoid unmounting the whole component
      if (callback) {
        callback(createdEncounter);
      } else {
        navigate(`/mobileEncounterDetails/${createdEncounter.encounter_id}`);
      }
    };
    setActiveButton('In visit');
    if (isMobileView) {
      setEncounterStatus('');
      dispatch(createEncounter(data, mobileCallback));
    } else {
      dispatch(createEncounter(data, desktopCallback));
    }
  };

  const onDemoEncounterTrigger = () => {
    setAuraDemoOpen({ retry: true });
  };
  const createDemoEncounter = ({ callback }) => {
    const current_date = new Date();
    const formattedDate = `${
      current_date.getMonth() + 1
    }/${current_date.getDate()}`;
    const description = `Encounter Demo - ${formattedDate}`;
    handleCreateEncounter(currentPractitioner.practitioner_id, {
      description,
      callback: callback || (() => {}),
      demo: true,
    });
  };

  const selectInitialRecordingTab = (record) => {
    const { displayStatus } = formatEncounterStatus(record);
    if (displayStatus.startsWith('Pre-chart')) {
      setActiveButton('Pre-chart');
    } else {
      setActiveButton('In visit');
    }
  };

  const configureRecordingTabs = () => {
    let tabs;

    const currentEncounter =
      encounterList &&
      encounterList?.find(
        (encounter) => encounter?.encounter_id === record?.encounter_id
      );
    const { displayStatus } = formatEncounterStatus(currentEncounter);

    if (
      displayStatus === 'Completed' ||
      displayStatus === 'Copied to EHR' ||
      displayStatus === 'Saved to EHR'
    ) {
      tabs = [
        { label: 'Completed note', value: 'In visit' },
        ...(settingsOrgValue?.org_settings?.enable_orders
          ? [{ label: 'Magic Orders', value: 'Orders' }]
          : []),
        { label: 'Dictate', value: 'Dictate' },
        { label: 'Documents', value: 'Documents' },
      ];
    } else {
      tabs = [
        { label: 'In visit', value: 'In visit' },
        { label: 'Dictate', value: 'Dictate' },
      ];
    }

    if (record.pre_chart_status != null) {
      tabs.unshift({
        label: 'Pre-chart',
        value: 'Pre-chart',
        showBanner: record.pre_chart_status === 'clinical-note-generated',
      });
    }

    setRecordingTabs(tabs);
  };

  useEffect(() => {
    if (!schedulepage) {
      configureRecordingTabs();
    }
  }, [record, encounterStatus, encounterList]);

  useEffect(() => {
    switch (activeButton) {
      case 'Documents':
        setEncounterPhase('after-visit');
        break;
      case 'In visit':
        setEncounterPhase('in-visit');
        break;
      case 'Pre-chart':
        setEncounterPhase('pre-chart');
        break;
      case 'Orders':
        setEncounterPhase('orders');
        break;
      case 'Dictate':
        setEncounterPhase('dictate');
        break;
      case 'VCA summary':
        setEncounterPhase('vca-summary');
        break;
      default:
        setEncounterPhase('in-visit');
    }
  }, [activeButton]);
  const { isEntitled: hasICD10Access } = useFeatureEntitlements('icd-10');
  const { isEntitled: pinnedEncountersEntitled } =
    useFeatureEntitlements('pinned-encounters');
  const { isEntitled: hasCPTAccess } = useFeatureEntitlements('cpt');
  const { isEntitled: hasSNOMEDAccess } = useFeatureEntitlements('snomed');

  //Function that happens when a row is clicked in encounters table
  const setCurrentEncounter = (record) => {
    editableSummaryRef.current = null;
    setEditedSummary(null);
    setIsSaving(false);
    setFullTranscript([]);
    setLiveTranscript([]);
    setLivePartialTranscript('');
    initTranscript.current = false;
    // set the active tab based on current encounter state.
    if (!schedulepage) {
      selectInitialRecordingTab(record);
    }

    if (!schedulepage) {
      storeInLocal(`${currentPractitioner?.org_uuid}_fromSchedulePage`, false);
    }

    if (!newEncounterfromMic) {
      setRecord(record);
      if (!isMobileView && record?.encounter_id) {
        dispatch(getEncounter(record?.encounter_id));
        dispatch(
          listSummaries(record?.encounter_id, encounterPhase, 'ambient')
        );
        dispatch(
          listSummaries(record?.encounter_id, encounterPhase, 'dictate')
        );
        dispatch(
          getTranscription(record?.encounter_id, encounterPhase, 'live')
        );
        if (isDiarizationEntitled) {
          dispatch(
            getTranscription(
              record?.encounter_id,
              encounterPhase,
              'prerecorded'
            )
          );
        }
      }
    }

    dispatch(selectedEncounterSlice(record));

    changeEncounterStatus(record?.encounter_id);

    if (record?.encounter_id) {
      const status = getEncounterStatus(record, encounterPhase);
      dispatch(getDictateSummary(record?.encounter_id));
      if (
        status === 'completed' &&
        encounterPhase == 'in-visit' &&
        hasICD10Access
      ) {
        setActiveRightPanelTab('icd10');
      } else {
        setActiveRightPanelTab('live');
      }
    }
  };

  //Functions to change description of an encounter
  const handleDescriptionChange = (e, record) => {
    const updatedEncounter = { ...record, description: e.target.value };
    setEditingRow(updatedEncounter);
  };

  const handleSaveDescription = (record) => {
    const params = {
      ...storedParams,
    };
    if (!editingRow.description.trim()) {
      toast.error('Description cannot be empty!');
      return;
    }

    if (schedulepage) {
      analytics.track("Edited Encounter's Description From VCA", {
        email: user?.email,
      });
    } else {
      analytics.track("Edited Encounter's Description From Aura", {
        email: user?.email,
      });
    }

    dispatch(
      updateEncounter(
        record.encounter_id,
        encounterPhase,
        { description: editingRow.description },
        params,
        selectedPractitioner,
        false
      )
    );
    setEditingRow(null);
  };
  //Functions to change description of an encounter

  const handleCancelEdit = () => {
    if (schedulepage) {
      analytics.track(
        "Clicked Cancel After Clicking Edit Encounter's Description From VCA",
        { email: user?.email }
      );
    } else {
      analytics.track(
        "Clicked Cancel After Clicking Edit Encounter's Description From Aura",
        { email: user?.email }
      );
    }

    setEditingRow(null);
  };

  //Function to copy contents from medical notes to the clipboard
  const handleCopy = () => {
    if (schedulepage) {
      analytics.track(
        'Clicked Copy As Rich Text In Ambient Medical Notes From VCA',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        'Clicked Copy As Rich Text In Ambient Medical Notes From Aura',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    }

    if (
      (!editableSummaryRef.current?.summary_json ||
        editableSummaryRef.current?.summary_json?.trim() === '') &&
      !getUuid?.appointment_details?.llm_intake_summary_forms
    ) {
      toast.info('No data available to copy');
      return;
    }

    try {
      let medicalConversation =
        typeof editableSummaryRef.current?.summary_json === 'string'
          ? editableSummaryRef.current?.summary_json
              ?.replaceAll('\n', '<br>')
              .replaceAll('\\n', '<br>')
          : editableSummaryRef.current?.summary_json;

      if (
        getUuid?.appointment_details?.llm_intake_summary_forms &&
        encounterPhase === 'in-visit'
      ) {
        medicalConversation +=
          getUuid?.appointment_details?.llm_intake_summary_forms;
      }

      const tempElement = document.createElement('div');
      const additionalInfo = `<strong>Encounter Name:</strong> ${
        record.description
      }<br><strong>Date:</strong> ${moment(record.created_at).format(
        'MMM Do, YYYY'
      )}<br><br>`;
      // Sanitize the HTML content before setting innerHTML
      tempElement.innerHTML = sanitizeHtmlContent(
        additionalInfo + medicalConversation
      );
      document.body.appendChild(tempElement);
      const range = document.createRange();
      range.selectNode(tempElement);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand('copy');
      document.body.removeChild(tempElement);
      toast.success('Copied to clipboard');
    } catch (error) {
      toast.error('Failed to copy medical notes');
    }
  };

  //Function to copy contents from transcriptions to the clipboard
  const transcriptcopy = () => {
    if (schedulepage) {
      analytics.track(
        'Clicked Copy As Rich Text In Ambient Transcript From VCA',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    } else {
      analytics.track(
        'Clicked Copy As Rich Text In Ambient Transcript From Aura',
        {
          transcription: transcriptionbyIdValue[0]?.transcription_id,
          email: user?.email,
        }
      );
    }

    const transcription = transcriptionbyIdValue[0];
    if (
      !transcription ||
      !transcription.transcription_json ||
      !transcription.transcription_json.length
    ) {
      toast.info('No transcription data available');
      return;
    }
    const encounterName = record?.description || 'N/A';
    const startTime = record?.start_time
      ? moment(record.start_time).format('MMM Do, YYYY')
      : 'N/A';
    const additionalInfo = `<strong>Encounter Name:</strong> ${encounterName}<br><strong>Start Time:</strong> ${startTime}<br><br>`;
    const textToCopy =
      additionalInfo +
      transcriptionbyIdValue[0]?.transcription_json
        .map(
          (transcription) =>
            `Speaker ${transcription.speaker}:\n${transcription.text}`
        )
        .join('\n\n');
    const htmlToCopy = textToCopy.replace(/\n/g, '<br>').trim();
    navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': new Blob([textToCopy], { type: 'text/plain' }),
        'text/html': new Blob([htmlToCopy], { type: 'text/html' }),
      }),
    ]);
    toast.success('Transcription copied to clipboard');
  };

  useEffect(() => {
    if (encounterPhase === 'dictate' && !waitingForSocketConnection) {
      setIsDictateTooltipOpen(true);
    } else {
      setIsDictateTooltipOpen(false);
    }
  }, [encounterPhase]);

  const handleQrCodeOpen = (record) => {
    setStoreQRcodeId(record?.encounter_id);
    setIsQRCodeOpen(true);
  };

  const showMicrophoneBar = useMemo(() => {
    if (!(isChartStreaming || isVisitStreaming)) return false;

    if (isVisitStreaming) return activeButton != 'In visit';

    if (isChartStreaming) return activeButton != 'Pre-chart';

    return true;
  }, [isChartStreaming, isVisitStreaming, activeButton]);

  useEffect(() => {
    return () => {
      endStream();
      setwaitingForSocketConnection(false);
      setDictationStarted(false);
      medicalConversationBoxRef.current?.stopDictation();
    };
  }, []);

  useEffect(() => {
    const savedEncounter = getSelectedEncounter();
    if (savedEncounter) {
      setRecord(savedEncounter);
      setIsStreaming(false);
      setIsRecording(false);
      setCurrentEncounter(savedEncounter);
    }
  }, []);

  const showOnboardingModal = practitonerPreferenceModal || !!auraDemoOpen;

  const getOnboardingModal = () => {
    if (practitonerPreferenceModal) {
      return (
        <NotePreferencesModal
          open={practitonerPreferenceModal}
          onCancel={() => setPractitonerPreferenceModal(null)}
        />
      );
    }

    return (
      <EncounterDemo
        open={!!auraDemoOpen}
        onClose={() => setAuraDemoOpen(null)}
        isRetryAttempt={auraDemoOpen?.retry}
        legacySearchFilters={storedParams}
      />
    );
  };

  useEffect(() => {
    if (ehrSubmitDocument?.response && ehrSubmitDocument?.response?.success) {
      const ehr_patient_chart_url =
        ehrSubmitDocument?.response?.patient_chart_url ||
        settingsOrgValue?.org_settings?.ehr_patient_chart_url;
      analytics.track('Saved To EHR Successfully', {
        encounter_id: record?.encounter_id,
        email: user?.email,
      });
      toast.success('Saved to EHR successfully.');
    } else if (
      ehrSubmitDocument?.response &&
      !ehrSubmitDocument?.response?.success
    ) {
      analytics.track('Failed To Save To EHR', {
        encounter_id: record?.encounter_id,
        email: user?.email,
      });
      toast.error('Failed to save to EHR');
    } else if (ehrSubmitDocumentStatus === 'error') {
      analytics.track('Failed To Save To EHR', {
        encounter_id: record?.encounter_id,
        email: user?.email,
      });
      toast.error('Failed to save to EHR');
    }
  }, [ehrSubmitDocument?.response, ehrSubmitDocumentStatus]);

  // Add state for rollback loading
  const [isRollingBack, setIsRollingBack] = useState(false);

  // Add rollback handler
  const handleRollback = (toSummary) => {
    if (schedulepage) {
      analytics.track('Clicked Rollback Summary From VCA', {
        encounter: record?.encounter_id,
        email: user?.email,
      });
    } else {
      analytics.track('Clicked Rollback Summary From Aura', {
        encounter: record?.encounter_id,
        email: user?.email,
      });
    }

    setIsRollingBack(true);
    dispatch(
      rollbackSummary(
        record?.encounter_id,
        encounterPhase,
        toSummary?.version,
        lastUpdatedSummaryRef,
        editableSummaryRef,
        setEditedSummary,
        setIsRollingBack
      )
    );
  };

  useEffect(() => {
    if (encounterPhase === 'pre-chart') {
      setActiveRightPanelTab('live');
    }
  }, [encounterPhase]);

  useEffect(() => {
    dispatch(clearSelectedTemplate());
    dispatch(clearTemplateHistory());
  }, [dispatch, encounterPhase, summaryList]);

  return (
    <>
      {/* Mobile view starts here */}
      {isMobileView ? (
        <div>
          {showOnboardingModal ? (
            getOnboardingModal()
          ) : (
            <PastEncounterMobileView
              encounterPhase={encounterPhase}
              setSearchFilters={setSearchFilters}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              topBarInputs={topBarInputs}
              setTopBarInputs={setTopBarInputs}
              encounterStatus={encounterStatus}
              startDate={startDate}
              endDate={endDate}
              activeButton={activeButton}
              setActiveButton={setActiveButton}
              handleCreateEncounter={handleCreateEncounter}
              onCreateEncounter={() =>
                handleCreateEncounter(currentPractitioner?.practitioner_id, {
                  is_pinned_encounter: true,
                })
              }
              selectedEncounterDetails={selectedEncounter}
              encounterList={encounterList}
              isEncounterListLoading={isEncounterListLoading}
              selectedEncounter={selectedEncounter}
              sortState={sortState}
              pageState={pageState}
              encounterListCount={encounterListCount}
              storedParams={storedParams}
              record={record}
              humanScribeStatus={humanScribeStatus}
              editableSummary={editableSummaryRef.current?.summary_json}
              editableSummaryOnChange={handleSummaryEdits}
              transcriptions={transcriptions}
              setPageState={setPageState}
              searchFilters={searchFilters}
              auraDemoOpen={auraDemoOpen}
              onDemoEncounterTrigger={onDemoEncounterTrigger}
              handleCopy={handleCopy}
              handleSummaryEdits={handleSummaryEdits}
              transcriptcopy={transcriptcopy}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
              editableSummaryRef={editableSummaryRef}
              isSummaryOutdated={isSummaryOutdated}
              setRecord={setRecord}
              editingRow={editingRow}
              handleDescriptionChange={handleDescriptionChange}
              handleSaveDescription={handleSaveDescription}
              handleCancelEdit={handleCancelEdit}
              setEditingRow={setEditingRow}
              handleQrCodeOpen={handleQrCodeOpen}
              setSelectedLastWeek={setSelectedLastWeek}
              setSelectedTabDate={setSelectedTabDate}
              today={today}
              handleRowClick={setCurrentEncounter}
              isStreaming={isStreaming}
              setIsStreaming={setIsStreaming}
              isRecording={isRecording}
              setIsRecording={setIsRecording}
              selectedPractitioner={selectedPractitioner}
              setSelectedPractitioner={setSelectedPractitioner}
              schedulepage={schedulepage}
              setEncounterStatus={setEncounterStatus}
              changeEncounterStatus={changeEncounterStatus}
              setSelectedDate={setSelectedDate}
              setSavedStartDate={setSavedStartDate}
              recentSearchList={recentSearchList}
              suggestions={suggestions}
              isScribeSelected={isScribeSelected}
              setIsScribeSelected={setIsScribeSelected}
              handleEncountersSorting={handleEncountersSorting}
              setIsUpgradeModalVisible={setIsUpgradeModalVisible}
              handleUpgradeToProModal={handleUpgradeToProModal}
              patientDetails={patientDetails}
              settingsOrgValue={settingsOrgValue}
              ehrSettings={ehrSettings}
            />
          )}
        </div>
      ) : (
        // Mobile view ends here
        //  Desktop view starts here
        <EncounterDesktopView
          storedFilter={storedFilter}
          schedulepage={schedulepage}
          isMinimized={isMinimized}
          showOnboardingModal={showOnboardingModal}
          getOnboardingModal={getOnboardingModal}
          sortState={sortState}
          auraDemoOpen={auraDemoOpen}
          startDate={startDate}
          endDate={endDate}
          searchFilters={searchFilters}
          selectedPractitioner={selectedPractitioner}
          savedStartDate={savedStartDate}
          savedEndDate={savedEndDate}
          handleCreateEncounter={handleCreateEncounter}
          storedParams={storedParams}
          isRowDoubleClicked={isRowDoubleClicked}
          auraView={auraView}
          setSearchFilters={setSearchFilters}
          setStartDate={setStartDate}
          setAuraView={setAuraView}
          setIsMinimized={setIsMinimized}
          setCurrentEncounter={setCurrentEncounter}
          livePartialTranscript={livePartialTranscript}
          encounterPhase={encounterPhase}
          setEndDate={setEndDate}
          handleBackMobileIconClick={handleBackMobileIconClick}
          topBarInputs={topBarInputs}
          setTopBarInputs={setTopBarInputs}
          encounterStatus={encounterStatus}
          activeButton={activeButton}
          setActiveButton={setActiveButton}
          encounterListWithColors={encounterListWithColors}
          setPageState={setPageState}
          setSelectedPractitioner={setSelectedPractitioner}
          handleCancelModal={handleCancelModal}
          modalVisible={modalVisible}
          isCustomSelected={isCustomSelected}
          setIsCustomSelected={setIsCustomSelected}
          setModalVisible={setModalVisible}
          selectedDate={selectedDate}
          liveTranscript={liveTranscript}
          setFullTranscript={setFullTranscript}
          restrictTemplates={restrictTemplates}
          setLivePartialTranscript={setLivePartialTranscript}
          record={record}
          recentSearchList={recentSearchList}
          setSavedEndDate={setSavedEndDate}
          fullTranscript={fullTranscript}
          setIsStreaming={setIsStreaming}
          setLiveTranscript={setLiveTranscript}
          setSavedStartDate={setSavedStartDate}
          setRecord={setRecord}
          setIsRecording={setIsRecording}
          isRecording={isRecording}
          isStreaming={isStreaming}
          changeEncounterStatus={changeEncounterStatus}
          setEncounterStatus={setEncounterStatus}
          setSelectedDate={setSelectedDate}
          handleRowDoubleClick={handleRowDoubleClick}
          humanScribeStatus={humanScribeStatus}
          editingRow={editingRow}
          setEditingRow={setEditingRow}
          handleCancelEdit={handleCancelEdit}
          selectedEncounterValue={selectedEncounterValue}
          medicalConversationBoxRef={medicalConversationBoxRef}
          activeRightPanelTab={activeRightPanelTab}
          setActiveRightPanelTab={setActiveRightPanelTab}
          editedSummary={editedSummary}
          handleQrCodeOpen={handleQrCodeOpen}
          pageState={pageState}
          onDemoEncounterTrigger={onDemoEncounterTrigger}
          recordingTabs={recordingTabs}
          editableSummaryRef={editableSummaryRef}
          isMagicEditingRef={isMagicEditingRef}
          autoResumeVisit={autoResumeVisit}
          onAutoResumeComplete={onAutoResumeComplete}
          isSaving={isSaving}
          isSummaryOutdated={isSummaryOutdated}
          isDictateTooltipOpen={isDictateTooltipOpen}
          dictationStarted={dictationStarted}
          handleDictation={handleDictation}
          waitingForSocketConnection={waitingForSocketConnection}
          handleRollback={handleRollback}
          isRollingBack={isRollingBack}
          handleSummaryEdits={handleSummaryEdits}
          showMicrophoneBar={showMicrophoneBar}
          isChartRecording={isChartRecording}
          isChartStreaming={isChartStreaming}
          isVisitRecording={isVisitRecording}
          isVisitStreaming={isVisitStreaming}
          setIsChartStreaming={setIsChartStreaming}
          setIsChartRecording={setIsChartRecording}
          setIsVisitRecording={setIsVisitRecording}
          setIsVisitStreaming={setIsVisitStreaming}
          patientDetails={patientDetails}
          handleEditTranscription={handleEditTranscription}
          setwaitingForSocketConnection={setwaitingForSocketConnection}
          setDictationStarted={setDictationStarted}
          // practitioner_options={practitioner_options}
          suggestions={suggestions}
          isScribeSelected={isScribeSelected}
          setIsScribeSelected={setIsScribeSelected}
          restrictNoteAccess={restrictNoteAccess}
          handleEncountersSorting={handleEncountersSorting}
          setIsUpgradeModalVisible={setIsUpgradeModalVisible}
          isTranscribing={isTranscribing}
          setIsTranscribing={setIsTranscribing}
          initTranscript={initTranscript}
          totalEncounterWillBeArchived={totalEncounterWillBeArchived}
          handleUpgradeToProModal={handleUpgradeToProModal}
          settingsOrgValue={settingsOrgValue}
          ehrSettings={ehrSettings}
        />
      )}
      {/* Desktop view ends here */}
      <QRcodeEncounter
        isOpen={isQRCodeOpen}
        setIsOpen={setIsQRCodeOpen}
        storeQRcodeId={storeQRcodeId}
      />
      {((timeBasedQuotaDaysRemaining !== null &&
        timeBasedQuotaDaysRemaining <= 0) ||
        (encountersRemaining !== null && encountersRemaining <= 0)) && (
        <UpgradeToProOPModal
          isVisible={isOPUpgradeModalVisible}
          setIsVisible={setIsUpgradeModalVisible}
          practitionerId={currentPractitioner.practitioner_id}
        />
      )}
      <UpgradeModal
        isVisible={isUpgradeToProModalVisible}
        setIsVisible={setIsUpgradeToProModalVisible}
      />
    </>
  );
};

export default PastEncounters;
